export default __webpack_public_path__ + "static/media/sindh.349191d5.svg";